import classNames from "classnames";
import PropTypes from "prop-types";

import "./browser-preview.scss";
import BrowserIcon from "./BrowserIcon.jsx";

const BrowserPreview = ({ wrapperClassName, className, children }) => (
  <div
    className={classNames("neeto-molecules-browser-preview", wrapperClassName)}
    data-testid="browser-preview"
  >
    <div className="neeto-molecules-browser-preview__header">
      <BrowserIcon />
    </div>
    <div
      className={classNames("neeto-molecules-browser-preview__body", className)}
      data-testid="browser-preview-body"
    >
      {children}
    </div>
  </div>
);

BrowserPreview.propTypes = {
  /**
   * The content to be rendered inside the browser preview body.
   */
  children: PropTypes.node,
  /*
   * To provide additional classes to the browser preview container.
   */
  wrapperClassName: PropTypes.string,
  /*
   * To provide additional classes to the browser preview body.
   */
  className: PropTypes.string,
};

export default BrowserPreview;
